import React, { Component } from 'react';
import { Box } from '@chakra-ui/react';

class TaskbarItem extends Component {
  render() {
    const { props } = this;
    return (
      <Box
        bg={props.isActive ? 'red.100' : 'red.500'}
        h={30}
        minW={50}
        maxW={150}
        px={2}
        cursor={'pointer'}
        textTransform={'uppercase'}
        fontSize={24}
        color={props.isActive ? 'black' : 'white'}
        onClick={() => {
          props.setActiveWindow(props.id);
        }}
      >
        {props.name}
      </Box>
    );
  }
}

export default TaskbarItem;
